import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { IconInfo } from 'UIPackage/IconsModule/components/IconInfo';
import { Tooltip } from 'UIPackage/MainModule/components/Tooltip';

import { importFileStatuses } from '../constants/importFileStatuses';
import { IImportRow } from '../interfaces/IImportRow';
import styles from './ImportFileStatusCell.module.scss';

export function ImportFileStatusCell({ row }: ITableRenderCell<IImportRow>) {
  const { fileStatus } = row;
  const fileStatusCode = importFileStatuses.find(status => status.name === fileStatus)?.id;

  return (
    <>
      {fileStatus}
      {fileStatusCode === 'NOT_CREATED' && (
        <Tooltip
          placement="topLeft"
          content={
            <div className={styles.TooltipContent}>
              План/проверка не созданы в связи с ошибками. Скачайте файл с ошибками, исправьте ошибки и повторите
              загрузку.
            </div>
          }
        >
          <span>
            <IconInfo className={styles.TooltipIconDanger} />
          </span>
        </Tooltip>
      )}
      {fileStatusCode === 'PROCESSING_FAILED' && (
        <Tooltip
          placement="topLeft"
          content={
            <div className={styles.TooltipContent}>
              План/проверка не созданы в связи с ошибками. Скачайте файл с ошибками, исправьте ошибки и повторите
              загрузку.
            </div>
          }
        >
          <span>
            <IconInfo className={styles.TooltipIconDanger} />
          </span>
        </Tooltip>
      )}
      {fileStatusCode === 'CREATED_WARNINGS' && (
        <Tooltip
          placement="topLeft"
          content={
            <div className={styles.TooltipContent}>
              План/проверка созданы с замечаниями. Скачайте файл с замечаниями, исправьте ошибки и повторите загрузку.
            </div>
          }
        >
          <span>
            <IconInfo className={styles.TooltipIconWarning} />
          </span>
        </Tooltip>
      )}
      {fileStatusCode === 'IMPOSSIBLE_TO_CORRECT' && (
        <Tooltip
          placement="topLeft"
          content={<div className={styles.TooltipContent}>Невозможно импортировать утвержденный план</div>}
        >
          <span>
            <IconInfo className={styles.TooltipIconWarning} />
          </span>
        </Tooltip>
      )}
    </>
  );
}
